const zipFormWidget = () => {

  // open HSI widget upon zip code completion (zip validated in frontend field)
  window.clwpForm.addAction('hsi-widget', formData => new Promise(resolve => {

    const form = document.getElementsByClassName('zip-form--simple__action-form')[0];

    if (form) {
      if (form.getAttribute('data-action') === 'hsi-widget') {
        const zip = formData.get('zip');
        const kbid = '111697'; // hardcoded, currently no place for hidden field type in form_input_with_button
        const zipWidget = document.getElementsByClassName('zip-form--simple')[0];

        // create iframe if not already there
        const iframe = document.getElementById('hsi-widget-results') || document.createElement('iframe');
        iframe.className = 'hsi-widget__results';
        iframe.id = 'hsi-widget-results';
        iframe.src = `https://www.highspeedinternet.com/widget?business&limit=5&zip=${zip}&kbid=${kbid}`;
        iframe.width = '100%';
        iframe.height = '600px';

        // append iframe after the zip form component
        zipWidget.after(iframe);
      }

    }

    resolve({
      success: true,
      data: {
        message: '',
      },
    });

  }));

};

export default zipFormWidget;
